import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { Page, Props } from '@grandvisionhq/www-next/pages/search'

import { withCms, withLayout } from '../cms'
import { featureToggles } from '../configuration/feature-toggles'

const { isMultilingualEnabled } = featureToggles

export const SearchPage: NextPage<Props> = (props) => {
  return <Page {...props} />
}

const getInitialProps = Page.getInitialProps
if (getInitialProps) {
  SearchPage.getInitialProps = (ctx) =>
    getInitialProps({ ...ctx, pageConfig: { isMultilingualEnabled } })
}

export default compose<Props, Props>(withCms(), withLayout())(SearchPage)
